import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-p-10 modal-verify-domain" }
const _hoisted_2 = { class: "tw-p-[40px] tw-bg-[#F7F7F8] tw-rounded tw-border tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_3 = { class: "tw-text-[16px] tw-font-[600] tw-text-[#211F58]" }
const _hoisted_4 = { class: "tw-mt-[10px] tw-text-[15px] tw-mb-0 tw-text-[#231F20]" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "button-container tw-flex tw-justify-end tw-mt-[40px]" }
const _hoisted_7 = { class: "button-container-right" }

import store from "@/store";
import utilities, { getComponentUiText } from "@/utils/utilities";
import { Ref, computed, ref, watch } from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import CopyInfo from "@/components/common/copyInfo.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import BaseForm from "@/components/common/form/baseForm.vue";

const DEFAULT_MAX_WIDTH_MODAL = 65;


export default /*#__PURE__*/_defineComponent({
  __name: 'verifyResetPasswordModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  orgName: {
    type: String,
    required: true,
  },
  secretKey: {
    type: String,
    required: true,
  },
  isHideOverlay: {
    type: Boolean,
    default: true,
  },
  isCurrentUser: {
    type: Boolean,
    required: false,
  },
  fullName: {
    type: String,
    required: true,
  },
},
  emits: ["update:show", "update:reuqest", "close:modal"],
  setup(__props, { emit }) {

const props = __props;




let showRef: Ref<boolean> = ref(props.show);

const dynamicDescriptionTags: any = {
  "app-component-assessments-checklists-assessment-details-card-status-3": {
    openTag: "<span class='tw-font-semibold'>‘",
    closeTag: "’</span>",
  },
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const eventCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("close:modal");
};

const verifyRequest = async () => {
  eventCloseModal();
  emit("update:reuqest");
};

const getProcessedUIText = (id: string, tags: any) => {
  return utilities.getProcessedUIText(
    id,
    tags,
    languageSelectedText.value,
    defaultUiText.value,
  );
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%]",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    "is-hide-overlay": __props.isHideOverlay,
    onClose: eventCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: 
        _unref(getComponentUiText)(
          'app-settings-team-members-profile-modal-pwd-action-title-1',
        )
      ,
        onClose: eventCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-team-members-verify-reset-password-title-description",
            )), 1),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, [
              (__props.isCurrentUser)
                ? (_openBlock(), _createBlock(_unref(VRuntimeTemplate), {
                    key: 0,
                    template: 
                getProcessedUIText(
                  'app-settings-team-members-verify-reset-password-current-user-1',
                  dynamicDescriptionTags,
                )
              
                  }, null, 8, ["template"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-settings-team-members-verify-reset-password-other-name-user-1",
                  false,
                  { name: __props.fullName },
                )) + " ", 1),
                    _createVNode(_unref(VRuntimeTemplate), {
                      template: 
                  getProcessedUIText(
                    'app-settings-team-members-verify-reset-password-other-user-1',
                    dynamicDescriptionTags,
                  )
                
                    }, null, 8, ["template"])
                  ]))
            ])
          ]),
          _createVNode(CopyInfo, {
            class: "copy-info-container tw-mt-[25px] tw-pl-[20px] tw-pr-[14px] tw-py-[10px] tw-bg-[#FFFFFF] tw-rounded-md",
            text: __props.secretKey,
            "style-icon-css": 'tw-w-[18px] tw-h-[18px]'
          }, null, 8, ["text"])
        ]),
        _createVNode(BaseForm, {
          "enter-event": true,
          show: _unref(showRef),
          "onOn:submit": verifyRequest
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_b_button, {
                  "data-cy": "verify-reset-pwd-submit-button",
                  variant: "primary",
                  class: "button-verify tw-bg-[#387DFF] tw-py-[11px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getUiText(
                  "app-component-assessments-checklists-assessment-details-card-status-3",
                )), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "is-hide-overlay"]))
}
}

})